import { render, staticRenderFns } from "./TAfterInput.vue?vue&type=template&id=48723a6d&scoped=true&"
import script from "./TAfterInput.vue?vue&type=script&lang=js&"
export * from "./TAfterInput.vue?vue&type=script&lang=js&"
import style0 from "./TAfterInput.vue?vue&type=style&index=0&id=48723a6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48723a6d",
  null
  
)

export default component.exports